import React from 'react'
import PropTypes from 'prop-types'
import SubscriptionReadOnlyComponent from './SubscriptionReadOnlyComponent'

class SolutionsComponent extends React.PureComponent {
  render () {
    const {
      contact,
      subscription
    } = this.props

    return (
      <SubscriptionReadOnlyComponent
        contact={contact}
        subscription={subscription}
      />
    )
  }
}

SolutionsComponent.propTypes = {
  contact: PropTypes.object,
  subscription: PropTypes.object
}

export default SolutionsComponent
